import { Component, Input } from '@angular/core';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'c_card_need_permission',
    templateUrl: './c_card_need_permission.component.html',
    styleUrls: ['../common.scss', './c_card_need_permission.component.scss'],
    standalone: false
})
export class c_card_need_permission_component extends BaseComponent {
  @Input() title: string;
  @Input() permissionKey?: string;

  constructor() { super(); }
}
